import React from "react";
import { ChatCategory } from "services/ChatApi";

export interface IRHPCategoryCard {
  category: ChatCategory;
  selectCategory: (category: ChatCategory) => void;
}

export const RHPCategoryCard = (props: IRHPCategoryCard) => {
  const { category, selectCategory } = props;
  return (
    <div onClick={() => selectCategory(category)} className="flex flex-col gap-5px p-15px w-[455px] font-pt-sans bg-white border border-gray-20 rounded cursor-pointer hover:bg-white-hard hover:shadow-[0px_2px_4px_-1px_rgba(15,23,42,0.06)] hover:shadow-[0px_4px_6px_-1px_rgba(15,23,42,0.10)] hover:shadow-[0px_0px_1px_0px_rgba(15,23,42,0.06)]">
      <h5 className="text-12px font-normal text-brown-prime uppercase m-0">Ask about {category.name}</h5>
      <p className="text-black text-15px m-0">{category.description}</p>
    </div>
  );
};